import {
  CALL_SPORT_LABELS,
  type CallSport,
} from "@/lib/the-call/types";
import type { SupProfileKey } from "@/lib/conditions/sport-profiles";

export type CallPreferenceCategory = "ski" | "summer" | "sailing";

export type CallPreferenceOption = {
  sport: CallSport;
  label: string;
};

const OPTIONS_BY_CATEGORY: Record<CallPreferenceCategory, CallSport[]> = {
  ski: ["ski", "touring", "mtb"],
  summer: [
    "surf",
    "bodyboarding",
    "wind",
    "foil",
    "downwind-foil",
    "wing-foil",
    "sup",
    "swim",
    "diving",
  ],
  sailing: ["sailing-club", "sailing-hp"],
};

export function callPreferenceOptionsForCategory(
  category: CallPreferenceCategory,
  allowedSupProfiles: readonly SupProfileKey[] = [],
): CallPreferenceOption[] {
  const sports = category === "summer" && allowedSupProfiles.length > 0
    ? OPTIONS_BY_CATEGORY.summer.flatMap((sport) =>
      sport === "sup" ? [...allowedSupProfiles] : [sport])
    : OPTIONS_BY_CATEGORY[category];
  return sports.map((sport) => ({
    sport,
    label: CALL_SPORT_LABELS[sport],
  }));
}

export function callPreferenceCategoryForSport(
  value: string,
): CallPreferenceCategory {
  const key = value.toLowerCase().trim().replace(/_/g, "-");
  if (
    key === "ski" ||
    key === "piste" ||
    key === "off-piste" ||
    key === "offpiste" ||
    key === "touring" ||
    key === "mtb"
  ) {
    return "ski";
  }
  if (key === "sailing" || key === "sailing-club" || key === "sailing-hp") {
    return "sailing";
  }
  return "summer";
}
